<div class="shadow mt-4">
    <div class="card reportes-card">

        <!-- Encabezado -->
        <div class="card-header d-flex align-items-center justify-content-between flex-wrap">
            <div class="header-title">
                <h2 class="m-0">{{title | uppercase}}</h2>
                <small>Descargue en CSV las transacciones de ePayco y Credijamar por rango de fechas</small>
            </div>
            <div class="d-flex align-items-center header-actions">
                <button mat-stroked-button class="pill-button" matTooltip="Limpiar el rango de fechas"
                    [disabled]="loading" (click)="limpiar()">
                    <mat-icon>cleaning_services</mat-icon> Limpiar
                </button>
                <button mat-stroked-button class="pill-button pill-button-primary"
                    matTooltip="Generar y descargar el reporte" [disabled]="loading || !rangoValido" (click)="descargar()">
                    <mat-icon>download</mat-icon> {{loading ? 'Generando...' : 'Descargar'}}
                </button>
            </div>
        </div>

        <div class="card-body">

            <!-- Filtros -->
            <div class="filters">
                <mat-form-field appearance="outline">
                    <mat-label>Rango de fechas</mat-label>
                    <mat-date-range-input [rangePicker]="picker" [max]="maxDate" [disabled]="loading" required>
                        <input matStartDate placeholder="Fecha inicial" [(ngModel)]="fechaInicio" required>
                        <input matEndDate placeholder="Fecha final" [(ngModel)]="fechaFin" required
                            (keyup.enter)="descargar()">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                    <mat-hint>Ambas fechas son obligatorias · la final debe ser mayor o igual a la inicial</mat-hint>
                </mat-form-field>
            </div>

            <!-- Estado -->
            <div class="empty-state text-center">
                <mat-icon>{{loading ? 'hourglass_top' : 'summarize'}}</mat-icon>
                <p class="m-0" *ngIf="!loading">Seleccione el rango de fechas y presione Descargar.
                    El archivo se guardará como <code>epayco-credijamar_&#123;fechaInicio&#125;_&#123;fechaFin&#125;.csv</code></p>
                <p class="m-0" *ngIf="loading">Generando el reporte, esto puede tardar unos segundos...</p>
                <p class="m-0 progreso" *ngIf="loading && progreso && progreso.total > 1">
                    Tramo {{progreso.hechos + 1}} de {{progreso.total}}</p>
            </div>
        </div>
    </div>
</div>
